import React, { lazy } from 'react';
import { Wrench, AlertCircle, AlertTriangle, Settings, ShieldCheck, Car } from 'lucide-react';
import { SectionReveal, StaggerContainer, StaggerItem } from './SectionReveal';
export function TomosSection() {
  const tomos = [{
    num: '01',
    title: 'Mantenimiento Básico Sin Complicaciones',
    desc: 'Aprendé a revisar fluidos, batería, neumáticos y controles esenciales.',
    icon: <Wrench className="w-10 h-10 text-[#F5F5F5]" data-id="element-279" />,
    cover: 'https://cdn.magicpatterns.com/uploads/6gZTRzHux61ZdpDPNjmRmu/PAGINA_1.png'
  }, {
    num: '02',
    title: 'Luces del Tablero Sin Misterios',
    desc: 'Descubrí qué significa cada advertencia y cómo actuar correctamente.',
    icon: <AlertCircle className="w-10 h-10 text-[#F5F5F5]" data-id="element-280" />,
    cover: 'https://cdn.magicpatterns.com/uploads/vYnmmJ3DnTnXAgZQG3SSUP/ChatGPT_Image_4_jun_2026,_11_00_19.png'
  }, {
    num: '03',
    title: 'Emergencias en Ruta',
    desc: 'Pinchaduras, batería descargada, sobrecalentamiento y situaciones frecuentes.',
    icon: <AlertTriangle className="w-10 h-10 text-[#F5F5F5]" data-id="element-281" />,
    cover: 'https://cdn.magicpatterns.com/uploads/ePMz7CDTD8YMDfngsweVHb/ChatGPT_Image_4_jun_2026,_11_36_54.png'
  }, {
    num: '04',
    title: 'Mantenimiento Preventivo Inteligente',
    desc: 'Filtros, correas, revisiones periódicas y prevención de averías antes de que aparezcan.',
    icon: <Settings className="w-10 h-10 text-[#F5F5F5]" data-id="element-282" />,
    cover: 'https://cdn.magicpatterns.com/uploads/hyx9WHRy1zzi5e6EARgJK1/ChatGPT_Image_4_jun_2026,_11_23_16.png'
  }, {
    num: '05',
    title: 'Cómo No Ser Engañado en el Taller',
    desc: 'Presupuestos, diagnósticos, repuestos y garantías explicados de forma simple.',
    icon: <ShieldCheck className="w-10 h-10 text-[#F5F5F5]" data-id="element-283" />,
    cover: 'https://cdn.magicpatterns.com/uploads/3StX6jtKR2SsMgu2v7PJDx/ChatGPT_Image_4_jun_2026,_11_06_48.png'
  }, {
    num: '06',
    title: 'Comprar un Usado Sin Equivocarte',
    desc: 'Documentación, inspección rápida, prueba de manejo y señales de alerta.',
    icon: <Car className="w-10 h-10 text-[#F5F5F5]" data-id="element-284" />,
    cover: 'https://cdn.magicpatterns.com/uploads/vY3FDGZJAEBncQ4vJTGTQ4/ChatGPT_Image_4_jun_2026,_11_41_05.png'
  }];
  return <section className="py-20 md:py-32 bg-[#171717] border-b border-[#262626]" data-id="element-285">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-286">
        <SectionReveal className="text-center mb-16" data-id="element-287">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-288">
            ¿Qué incluye el MegaPack?
          </h2>
          <p className="text-xl text-[#F59E0B] font-heading tracking-wide" data-id="element-289">
            6 Tomos diseñados para llevarte de cero a confiado
          </p>
        </SectionReveal>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-290">
          {tomos.map((tomo, idx) => <StaggerItem key={idx} className="bg-[#0a0a0a] border border-[#262626] rounded-sm p-8 transition-all duration-300 hover:border-[#F59E0B] hover:-translate-y-1 amber-glow-hover relative overflow-hidden group" data-id="element-291">
              <div className="absolute -right-4 -bottom-10 font-heading text-9xl font-bold text-[#171717] z-0 select-none transition-colors group-hover:text-[#F59E0B]/5" data-id="element-292">
                {tomo.num}
              </div>

              <div className="relative z-10" data-id="element-293">
                <div className="flex items-start justify-between gap-4 mb-6" data-id="element-294">
                  <div className="bg-[#F59E0B] text-[#0a0a0a] font-heading font-bold text-xl px-4 py-1 rounded-sm tracking-widest self-start" data-id="element-295">
                    TOMO {tomo.num}
                  </div>

                  {/* Cover thumbnail (or icon fallback) */}
                  {tomo.cover ? <div className="w-20 md:w-24 flex-shrink-0 rounded-sm overflow-hidden border border-[#262626] shadow-lg shadow-black/50 group-hover:border-[#F59E0B]/50 transition-colors" data-id="element-296">
                      <img src={tomo.cover} alt={`Portada del Tomo ${tomo.num}: ${tomo.title}`} loading="lazy" className="w-full h-auto block" data-id="element-297" />
                    </div> : <div className="p-3 bg-[#171717] rounded-sm border border-[#262626] group-hover:border-[#F59E0B]/50 transition-colors flex-shrink-0" data-id="element-298">
                      {tomo.icon}
                    </div>}
                </div>

                <h3 className="text-2xl font-bold text-white mb-4 leading-tight" data-id="element-299">
                  {tomo.title}
                </h3>

                <p className="text-[#9CA3AF] leading-relaxed" data-id="element-300">{tomo.desc}</p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}